import { render, staticRenderFns } from "./AdminList.vue?vue&type=template&id=73bc3416&scoped=true&"
import script from "./AdminList.vue?vue&type=script&lang=js&"
export * from "./AdminList.vue?vue&type=script&lang=js&"
import style0 from "./AdminList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AdminList.vue?vue&type=style&index=1&id=73bc3416&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bc3416",
  null
  
)

component.options.__file = "AdminList.vue"
export default component.exports